import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findProductDiscount({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`productDiscount/findProductDiscount`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`productDiscount/save`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  }
  
}
